var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageContent } from "../../Organisms/Messages/Molecules";
import { Stack, Link } from "@mui/material";
import { Text } from "../../Atoms";
import { COLORS } from "../../../constants/colors";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
var ResetPasswordConfirmation = function (_a) {
    var _b = _a.message, message = _b === void 0 ? "You can now sign in with your new password." : _b;
    return (_jsx(MessageContent, __assign({ title: "Password Changed!", icon: _jsx(CheckCircleOutlineOutlinedIcon, { color: "primary", sx: { height: 48, width: 48 } }) }, { children: _jsxs(Stack, __assign({ direction: "column", spacing: 6, pt: 2, textAlign: "center" }, { children: [_jsx(Text, __assign({ variant: "body1" }, { children: message })), _jsxs(Text, __assign({ variant: "body2" }, { children: [_jsxs(Link, __assign({ href: "/login", color: COLORS.SHADED_COBALT, underline: "none", sx: {
                                fontWeight: 600,
                            } }, { children: ["Click here", " "] })), "if you are not redirected within 5 seconds."] }))] })) })));
};
export default ResetPasswordConfirmation;
